'use strict';

const isPlacesScriptLoaded = () => 'google' in window && 'maps' in window.google && 'places' in window.google.maps
/**
* Loads the google maps script
* @param {string} apiKey Google maps api key
* @returns {Promise} Pormise resolved when script is fully loaded
**/
const loadScript = () => {
    return new Promise((resolve) => {
        if (isPlacesScriptLoaded()) {
            //if already loaded, resolve the promise
            resolve();
            return;
        }
        
        const script = document.createElement('script');
        const apiKey = $('.key-holder').data('key');
        script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places,geocoding&loading=async`;
        script.defer = true;

        let interval = null;
        const checkPlacesScriptIsLoaded = () => {
            if (google.maps.places) {
                resolve()
                clearInterval(interval);
            }
        }

        script.onload = () => {
            interval = setInterval(checkPlacesScriptIsLoaded, 100);
        }
        document.head.appendChild(script);
    });
}

module.exports = {
    loadScript: loadScript,
    isPlacesScriptLoaded: isPlacesScriptLoaded
}